import { api } from 'api'
import { format } from 'date-fns'
import { WorkShift } from 'typings/common_defs'

export enum LogEventType {
  ShiftCreate = 'shift_create',
  ShiftModify = 'shift_modify',
  E2WReview = 'e2w_review',
  CompanyWorkerProfile = 'company_worker_profile',
  Work = 'work',
  UserPayment = 'user_payment',
  CompanyIssuedBonus = 'company_issued_bonus',
  RequestCallout = 'request_callout',
  ApproveCallout = 'approve_callout',
  RejectCallout = 'reject_callout',
  EmployerWorkApproved = 'employer_work_approved',
}

export interface CompanyLog {
  timestamp: string
  message: string
  userId: number
  companyId: number
  shiftId: number
  subjectUserId: number
  eventType: LogEventType
  user?: {
    id: number
    name: string
  }
  shift?: WorkShift
  subjectUser?: {
    id: number
    name: string
  }
}

const logDateFormat = "yyyyMMdd'T'HH:mm:ssx"
export async function getCompanyLogs(options: {
  companyId: number
  startDate: Date
  endDate: Date
}) {
  const { companyId, startDate, endDate } = options
  const response = await api.post<{ eventLogs: CompanyLog[] }>(
    `/company/graphql_dispatch/${companyId}/company_logs_f227532f`,
    {
      startsAt: startDate ? format(startDate, logDateFormat) : undefined,
      endsAt: endDate ? format(endDate, logDateFormat) : undefined,
    }
  )

  return response.data.eventLogs
}
